import React from 'react';
import { useQuery } from 'react-fetching-library';

import { getGlobalStatisticsDataAction } from '../../../services/request';
import { InfluenceChart } from './global/InfluenceChart';
import { ReservationsChart } from './global/ReservationsChart';
import { PromotionStatistics } from './global/PromotionStatistics';
import { FormRatingsChart } from './global/FormRatingsChart';

export const GlobalStatistics = () => {
  const { loading, payload, error } = useQuery(getGlobalStatisticsDataAction());
  const [influenceData, setInfluenceData] = React.useState([]);
  const [reservationsData, setReservationsData] = React.useState([]);
  const [formRatingsData, setFormRatingsData] = React.useState([]);

  React.useEffect(() => {
    if (!error && !loading) {
      setInfluenceData(payload.influence_data);
      setReservationsData(payload.reservations_data);
      setFormRatingsData(payload.ratings_data);
    }
  }, [loading]);

  return (
    <>
      <InfluenceChart data={influenceData} />
      <ReservationsChart data={reservationsData} />
      <FormRatingsChart data = {formRatingsData} />
      <PromotionStatistics />
    </>
  );

};
